import "./ToastMessage.css";
const ToastMessage = (props) => {
    let { message } = props;
    return (
        <div className="toast-success">{message}</div>
    )

}
export default ToastMessage